// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import * as onboarding from './apps/onboarding';

let onboardingUrl = 'https://smallbusiness-api.rise-staging.com';

export const environment = Object.assign(
  {
    production: true,
    benefitsUrl: 'http://benefits.dev',
    hubUrl: 'http://localhost:8001',
    payrollUrl: 'http://payroll.dev',
    timeoffUrl: 'http://localhost:8000',
    tokensUrl: 'http://192.168.1.30:8888/tokens',
    employeeInfoUrl: 'http://192.168.1.30:8888/employees/',
    realm: 'hazel',
    SENTRY_ENABLED: true,
    SENTRY_ENVIRONMENT_TYPE: 'production'
  },
  onboarding.environmentOfOnboarding(onboardingUrl)
);



// WEBPACK FOOTER //
// ./src/environments/environment.ts